// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2zwAA","colCheckbox":"styles_colCheckbox__2JcHV"};